import React from 'react'
import { styled, AppBar } from '@mui/material'
import { CONTEXT_BAR_HEIGHT } from './ContextBar'

/**
 * Inside the admin shell, its sidebar can be docked: the full height, over this bar, with the logo
 * and the open/close control at its top. The shell then marks <html> (`data-app-sidenav`) and
 * publishes the width it takes (`--app-sidenav-width`): the bar starts after it, and the header
 * drops its own logo and menu button. Run on its own, this app sees neither.
 */
export const SHELL_SIDENAV_DOCKED = 'html[data-app-sidenav="docked"] &'

const NavBar = styled(AppBar, { shouldForwardProp: (prop) => prop !== 'contextBar' })(({ theme, contextBar }) => ({
    ...(theme.palette.mode === "light" && {
        backgroundColor: theme.palette.background.paper,
        boxShadow: "none",
        color: theme.palette.primary.contrastText,
    }),
    ...(theme.palette.mode === "dark" && {
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxShadow: "none",
    }),
    zIndex: 1210,
    // A phone's restaurant / branch bar (ContextBar) sits inside it, under the row.
    height: contextBar ? 50 + CONTEXT_BAR_HEIGHT : 50,
    paddingLeft: 'var(--app-sidenav-width, 0px)',
    transition: theme.transitions.create('padding-left', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.standard,
    }),
}));

const NavBarRoot = ({ children, contextBar = false }) => {

    return (
        <NavBar contextBar={contextBar}>
            {children}
        </NavBar>
    )
}
export default NavBarRoot
